export default __webpack_public_path__ + "static/media/TermsOfUse-DE.a1751cd8.pdf";